import React from 'react';
import { useDispatch, useSelector } from "react-redux";

import WorkIcon from '@mui/icons-material/Work';
import WorkOffIcon from '@mui/icons-material/WorkOff';

import {
    dataViewStagedData
} from "../../redux/data/dataActions";

import { styled, useTheme, Switch, Grid, Typography, Tooltip } from '@mui/material';

const PREFIX = 'DataSettingsLayout';

const classes = {
    root: `${PREFIX}-root`,
    centerImage: `${PREFIX}-centerImage`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        margin: theme.spacing(2),
        height: 'calc(100% - 32px)',
        overflowX: 'hidden',
        overflowY: 'auto'
    },

    [`& .${classes.centerImage}`]: {
        width: '100%',
        height: '75px',
        // minHeight: '200px',
        display: "flex",
        flexDirection: "column",
        // justifyContent: "center",
        margin: '0px',
        // marginTop: '46px',
        // marginBottom: '45px'
    }
}));

export default function DataLoaderSettingsLayout() {

    const dispatch = useDispatch();

    // App Stage
    const viewStaged = useSelector(state => state.data.viewStaged);

    function handleToggleStaged() {
        dispatch(dataViewStagedData(!viewStaged));
    }

    return (
        <Root className={classes.root}>
            <Typography variant="body2" gutterBottom>
                Before <strong>Publishing</strong> any data, toggle the switch below and review the application.
            </Typography>
            <div className={classes.centerImage}>
                <div style={{height: '100px', textAlign: 'center', verticalAlign: 'middle', lineHeight: '100px'}}>
                    {!viewStaged &&
                    <Tooltip title="Let's get to work!" placement="right"><WorkIcon fontSize="large" /></Tooltip>
                    }
                    {viewStaged &&
                    <Tooltip title="Halt! Check your pages!" placement="right"><WorkOffIcon fontSize="large" /></Tooltip>
                    }
                </div>
            </div>
            <Typography component="div" style={{marginTop: '5px'}}>
                <Grid component="label" container alignItems="center" spacing={1} style={{paddingLeft: '20px'}}>
                    <Grid item>
                        <Typography variant="overline" display="block" style={{fontStyle: 'italic'}}>
                            Production Data
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Switch color="primary" checked={viewStaged ? true : false} onChange={handleToggleStaged} />
                    </Grid>
                    <Grid item>
                        <Typography variant="overline" display="block" style={{fontStyle: 'italic'}}>
                            Staged Data
                        </Typography>
                    </Grid>
                </Grid>
            </Typography>
            {/*<Typography variant="caption" display="block" style={{paddingTop: '12px', textAlign: 'right'}}>*/}
            {/*    caption text*/}
            {/*</Typography>*/}
        </Root>
    );
}
